<template>
  <div>
    <div class="xxzl flex" v-if="bannerList.length > 0">
      <div
        class="xxzl_img flex_1 flex my_card pointer"
        v-for="(item, index) in bannerList"
        :key="index"
        @click="goLinkClick(item)"
        :title="item.title"
      >
        <img
          v-lazy="
            item.imgPath
              ? `/apis${item.imgPath}`
              : required('../../../assets/imgs/placeholder/no_img.png')
          "
          alt=""
        />
      </div>
    </div>
    <img
      v-else
      style="height: 260px; margin: 0 auto"
      src="../../../assets/imgs/placeholder/no_img.png"
      alt=""
    />
  </div>
</template>

<script>
import { getInfoBannerApi } from "@/apis/api";
export default {
  name: "WorkspaceJsonXxzl",

  data() {
    return {
      bannerList: [],
    };
  },

  async mounted() {
    let res = await getInfoBannerApi();
    this.bannerList = res?.data?.slice(0, 2) || [];
  },

  methods: {
    goLinkClick(item) {
      if (item.linkUrl) {
        window.open(item.linkUrl, "_blank");
      }
    },
  },
};
</script>
<style lang="less" scoped>
.xxzl {
  .xxzl_img {
    margin-right: 16px;
    height: 260px;
    border-radius: 10px;
    overflow: hidden;
    > img {
      max-width: 100%;
      max-height: 100%;
      margin: auto;
    }
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>